//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: [
    "searchType", //查询类型
    "filterLoading", //加载。。
    "modelWidth", //弹框宽度
    "title_name", //标题
    "ascName", //正序名称
    "descName", //倒序名称
    "pd_name", //输入框默认提示placeholder 并 控制输入框显示
    "orderName", //排序关键词 同时控制是否显示排序
    "crrSortName", //当前排序值
    "crrOrderName", //当前排序参数名
    "filterWhere", //筛选已选json
    "pamName", //选中值json参数名
    "isSearch"
  ],
  data() {
    return {
      filterShow: false, //弹框显示
      crrSelect: []
    };
  },
  watch: {
    filterWhere() {
      this.crrSelect = this.filterWhere[this.pamName];
    }
  },
  mounted() {},
  methods: {
    addressHide(name, str) {
      const strLength = str.length;
      const nameLength = name.length;
      if (strLength + nameLength > 45) {
        let satrt = str.substring(0, 45 - nameLength - 5);
        let end = str.substring(strLength - 5, strLength);
        return satrt + "..." + end;
      } else {
        return str;
      }
    },
    cancelModel() {
      this.filterShow = false;
      this.crrSelect = this.filterWhere[this.pamName];
    },
    filterListSort(sort) {
      this.filterShow = false;
      this.$emit("filterListSort", this.orderName, sort);
    },
    f_back() {
      this.$emit("f_back", this.jsonName, this.pamName);
    },
    filterConfirm(pam1) {
      if (pam1 && !this.crrSelect.length) {
        this.$message("请选择要筛选的日期");
      } else {
        let data = this.filterWhere;
        data[pam1] = this.crrSelect;
        this.$emit("update:filterWhere", data);
        this.$emit("filterConfirm", pam1);
        this.filterShow = false;
      }
    },
    resetConfirm(pam1) {
      this.crrSelect = [];
      this.filterShow = false;
      let data = this.filterWhere;
      console.log(this.filterWhere, 11111111);
      data[pam1] = [];
      console.log(data, 22222222);
      this.$emit("update:filterWhere", data);
      this.$emit("filterConfirm", pam1);
    }
  }
};
